/* eslint-disable @typescript-eslint/no-deprecated */

import React, { CSSProperties } from 'react'
import styled from 'styled-components'
import { Checkbox } from '../../buildingBlocks'
import { Tag } from '../../domain'
import { Caption } from '../../styles'
import { getTagColor } from './TagConfig'
import { TagIcon } from './TagIcon'

interface Props {
  tag: Tag
  onClick: () => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  selected: boolean
}

export const TagSelector: React.FC<Props> = ({ selected, onClick, tag, onMouseEnter, onMouseLeave }) => {
  return (
    <Outer onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <TagSelectorContainer highlightColor={getTagColor(tag.id)}>
        <OptionContainer>
          <Checkbox checked={selected} onChange={() => onClick()} />
          <TagIcon tagId={tag.id} style={TagIconStyles} />
          <div>
            <Caption>{tag.title}</Caption>
          </div>
        </OptionContainer>
      </TagSelectorContainer>
    </Outer>
  )
}

interface ContainerProps {
  highlightColor?: string
}

const Outer = styled.div`
  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey.light};
  }
`

const OptionContainer = styled.div`
  display: flex;
`

const TagSelectorContainer = styled.label<ContainerProps>`
  transition: all 0.3s;
  user-select: none;
  display: block;
  padding: 1rem;
  &:hover {
    background: ${({ theme }) => theme.colors.grey.light};
    border-right: 0.7rem solid ${(p) => (p.highlightColor ? p.highlightColor : 'transparent')};
  }
  border-right: 0.7rem solid transparent;
`

const TagIconStyles: CSSProperties = {
  width: '2.5rem',
  height: '2.5rem',
  objectFit: 'contain',
  borderRadius: '4px',
  verticalAlign: 'middle',
  margin: '0 2rem',
}
